app.service('giftCardOrderSelectionView', function (validate, modal, price, pageConfig, loading, broker, ajaxOrder, front) {
	var $self, $form, $modalForm, $cardValue, $cardStyle, $giftCardCustomStyle, $previewGroupName, $customValueField, $currentGiftCardValue, $sendButton;
	var $previewImage, $previewPrice, $giftCardPreviewWishes, $giftCardPreviewBlock, $summaryPrice, $summaryGroupName;
	var $currentGiftCardId, $currentGiftCardGreeting, $currentCustomWishesData;
	var $cardType, $customTypeGiftcard, $greetingListArray, $greetingGroupSelect, $greeting, $wishesTypeCheckbox, $customCardConfirmButton;
	var $predefinedWishes, $predefinedWishesSelected, $customWishes, $customWishesSelected, $customWishesTextarea, $customWishesTermsAccepted, $customWishesContentAgreement;
	var giftCardSelectedId = false;
	var predefinedWishesSelected = false, greetingSelected = false;
	var customWishesSelected = false; customWishesTextFilled = false, agreementsSelected = false;
	var currentGiftCardValue;
	var config;
	let isOneInit = false;

	function setElements() {
		config = pageConfig.getData('order');
		$self = $('#gift-card-order-selection');
		$form = $('#front-form', $self);

		$currentGiftCardId = $('#gift-card-style', $form);
		$currentGiftCardValue = $('#gift-card-value', $form);
		$currentGiftCardGreeting = $('#gift-card-greetings', $form);
		$currentCustomWishesData = $('#custom-wishes-data', $form);
		$currentTermsAccepted = $('#wishes-terms-accepted', $form);
		$currentAgreementToBlockContent = $('#wishes-content-agreement', $form);

		$cardValue = $('.js-card-value', $self);
		$customValueField = $('#custom-card-value', $self);
		$previewImage = $('.gift-card-preview-image', $self);
		$previewPrice = $('.gift-card-price', $self);
		$previewGroupName = $('.gift-card-preview-headline', $self);
		$giftCardPreviewWishes = $('.gift-card-preview-wishes', $self);
		$giftCardPreviewBlock = $('.gift-card-preview-block', $self);

		$summaryPrice = $('#summary-card-price', $self);
		$summaryGroupName = $('#summary-card-groupName', $self);

		$cardType = $('.js-card-type-select', $self);
		$customTypeGiftcard = $cardType.filter('[data-card-type="custom"]')

		$customizationModal = $('#modal-gift-card-customization');
		$modalForm = $('#gift-card-customization-form', $customizationModal);
		$cardStyle = $('.js-card-style', $customizationModal);
		$giftCardCustomStyle = $('#gift-card-custom-style', $customizationModal);
		$wishesTypeCheckbox = $('.js-wishes-type-check', $customizationModal);
		$customCardConfirmButton = $('.js-custom-card-confirm', $customizationModal);

		$greetingListArray = $('.greeting-list', $customizationModal);
		$greetingGroupSelect = $('#greeting-group-select', $customizationModal);
		$greeting = $('.js-greeting', $greetingListArray);

		$predefinedWishes = $('#predefined-wishes', $customizationModal);
		$predefinedWishesSelected = $('#predefined-wishes-selected', $customizationModal);
		$customWishes = $('#custom-wishes', $customizationModal);
		$customWishesSelected = $('#custom-wishes-selected', $customizationModal);
		$customWishesTextarea = $('#custom-wishes-textarea', $customizationModal);
		$customWishesTermsAccepted = $('#custom-wishes-terms-accepted', $customizationModal);
		$customWishesContentAgreement = $('#custom-wishes-content-agreement', $customizationModal);

		giftCardSelectedId = config.selectedGiftCardId;
		giftCardSelectedGroupName = config.selectedGiftCardGroupName;
		giftCardSelectedImagePath = config.selectedGiftCardImagePath;
		currentGiftCardValue = config.defaultCardValue;

		$sendButton = $('.js-gift-card-submit', $self);

		if (testAB.getVar('ajax-order') === 'B' && front.getParam('ajaxOrder')) {
			ajaxOrder.setForm($form);
		}
	}
	function next(){
		$form.submit();
	}

	function setEvents() {

		$cardValue.on('click', function () {
			$cardValue.removeClass('selected');
			if (!$(this).hasClass('input-card-value')) {
				$(this).addClass('selected');
			}
			setCardValue($(this).val() / 1);
		});

		$cardType.on('click', function (event) {
			event.preventDefault();
			var $this = $(this);

			if ($this.data('card-type') == 'custom') {
				modal.open('gift-card-customization');
			} else {
				$cardType.removeClass('selected');
				$this.addClass('selected');
				$currentGiftCardGreeting.val('');
				$giftCardPreviewWishes.html('');
				selectCardStyle($this.data('id'), $this.find('img').attr('src'), $this.data('group'));
			}

		});

		validate.task('giftCardOrderSelection');

		$sendButton.click(function () {
			next();
		})

		$customValueField.keyfilter(/[\d]/).on('focus click', function () {
			$cardValue.removeClass('selected');
			$customValueField.addClass('selected');
			var trimmed = $customValueField.val().replace(/\s/gi, '');
			setCardValue(trimmed);
			$customValueField.val(trimmed);
		}).on('blur', function () {
			var priceValidated = priceValidate($customValueField.val());
			if (priceValidated) {
				$customValueField.val(price.format(priceValidated, false));
				setCardValue(priceValidated);
			}
		}).on('keydown', function (event) {
			$customValueField.val($customValueField.val().slice(0, 4));
			if (event.keyCode == 13) {
				event.preventDefault();
			}
		}).on('keyup', function () {
			var trimmed = $customValueField.val().replace(/\s/gi, '');
			setCardValue(trimmed);
		});

		setCurrentDateForPreview();
		setPreviewScale();
		$(window).on('resize', setPreviewScale);

		$('.js-show-preview', $self).on('click', function () {
			modal.generate({
				id: 'gift-card-preview-modal',
				modifier: 'remodal-full-width',
				header: 'Podgląd Twojej karty podarunkowej',
				content: $('.gift-card-preview').first().clone().addClass('preview-on-modal').removeAttr('style'),
				callbackClose: function () {
					modal.destroy('gift-card-preview-modal');
				}
			});
		});

		$cardStyle.on('click', function () { //wybór wzoru grafiki
			$thisGiftCard = $(this);
			if ($thisGiftCard.hasClass('selected')) {
				$thisGiftCard.removeClass('selected');
				giftCardSelectedId = false;
				giftCardSelectedGroupName = '';
				giftCardSelectedImagePath = '';
				$giftCardCustomStyle.val('');
				$modalForm.validate().element($giftCardCustomStyle);

			} else {
				$cardStyle.removeClass('selected');
				$thisGiftCard.addClass('selected');
				giftCardSelectedId = $thisGiftCard.data('id');
				giftCardSelectedGroupName = $thisGiftCard.data('group');
				giftCardSelectedImagePath = $thisGiftCard.find('img').attr('src');
				$giftCardCustomStyle.val(giftCardSelectedId);
				$modalForm.validate().element($giftCardCustomStyle);
			}
		});

		$greetingGroupSelect.on('change', function () {
			var groupId = $(this).val();
			$greeting.removeClass('selected');
			$predefinedWishesSelected.val('');
			showSelectedGreetingsGroup(groupId);
			$modalForm.validate().element($predefinedWishesSelected);
		});

		$greeting.on('click', function () { // zaznaczenie życzeń z dostępnej listy
			$greeting.removeClass('selected');
			$(this).addClass('selected');
			$predefinedWishesSelected.val('true');
			$modalForm.validate().element($predefinedWishesSelected);
		});

		$wishesTypeCheckbox.on('click', function () { //checkbox dodania życzeń
			var $this = $(this);
			var $thisWishesSection = $('#' + $this.attr('id') + '-section');

			// można zaznaczyć tylko jeden checkbox albo odznaczyć obydwa
			$wishesTypeCheckbox.not($this).prop('checked', false);
			$('.checkbox-section').not($thisWishesSection).removeClass('show');

			$this.is(':checked') ? $thisWishesSection.addClass('show') : $thisWishesSection.removeClass('show');
		});

		$customWishesTextarea.keyfilter(/[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9@:.,!?\-\(\)\s]/);

		$customCardConfirmButton.on('click', function () {
			if ($modalForm.valid()) {
				sendModalForm();
			}
		});
		if (!isOneInit) {
			broker.on('ORDER-NEXT-STEP', function () {
				if(front.page() == 'gift-card-order-selection'){
					next();
				}
			});
			isOneInit = true;
		}
	}
	function sendModalForm() {
		loading.start();
		$.ajax({
			url: '/gift-card-validate-greetings.ltr',
			dataType: 'json',
			data: {
				greetings: $customWishesTextarea.val()
			},
			success: function (json) {
				loading.stop();
				if (json.status === 'OK') {
					saveCustomization();
				} else if (json.status === 'ERROR') {
					loading.stop();
					showGeetingsBadWordError(json.errorMessage);
				} else {
					modal.alert('Brak obsługi odpowiedzi')
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd wysyłania danych. Spróbuj ponownie');
			}
		});
	}
	function showGeetingsBadWordError(errorMessage) {
		const $validationBlock = $customWishesTextarea.parent();
		//kontener do prezentacji błędu (z walidacji wulgaryzmów) na wzór standardowego z validate.js
		const $errorContainer = `<label id="custom-wishes-textarea-error" class="error label-error" for="custom-wishes-textarea">${errorMessage}</label>`
		$validationBlock.removeClass('validate-ok').addClass('validate-error');
		$customWishesTextarea.addClass('error');
		$validationBlock.parent().append($errorContainer);
		// pole $customWishesTextarea ma nałożoną regułę na wymagane wypełnienie pola, więc próba ponownego wysłania formularza usuwa append'owany element
	}

	function saveCustomization() {
		// zapisanie parametrów
		var wishesHtml = '';
		var params = {
			cardId: giftCardSelectedId,
			cardSrc: giftCardSelectedImagePath,
			groupName: giftCardSelectedGroupName,
		}
		// pobranie aktualnych wartości formularza
		predefinedWishesSelected = $predefinedWishes.is(':checked');
		greetingSelected = $greeting.hasClass('selected');
		customWishesSelected = $customWishes.is(':checked');
		customWishesTextFilled = $customWishesTextarea.val().length > 0;
		agreementsSelected = $customWishesTermsAccepted.is(':checked') && $customWishesContentAgreement.is(':checked');

		if (predefinedWishesSelected && greetingSelected) {
			wishesHtml = $greeting.filter('.selected').html();
			params.whishes = wishesHtml.replace(/<br>/g, '\n').trim();
		} else if (customWishesSelected && customWishesTextFilled && agreementsSelected) {
			var plainWishes = $customWishesTextarea.val();
			wishesHtml = plainWishes.replace(/\n/g, '<br>');
			params.whishes = plainWishes.trim();
			params.termsAccepted = $customWishesTermsAccepted.is(':checked'),
				params.agreementToBlockContent = $customWishesContentAgreement.is(':checked')
		}
		// zaznaczenie personalizowanego typu karty (kafelek)
		$cardType.removeClass('selected');
		$customTypeGiftcard.addClass('selected');

		// prezentacja treści z modala na kafelku personalizacji karty
		$customTypeGiftcard.find('.gift-card-image').html('<img src="' + params.cardSrc + '" alt="' + params.groupName + '"/>');
		$customTypeGiftcard.find('.gift-card-type-name').text(params.groupName);
		$customTypeGiftcard.find('.gift-card-type-info').html('Wybrany wzór' + (wishesHtml != '' ? ' i&nbsp;życzenia' : ''));
		$customTypeGiftcard.find('.gift-card-wishes').html(wishesHtml);

		// ustawienie treści na preview
		selectCardStyle(params.cardId, params.cardSrc, params.groupName != config.defaultGiftCardGroupName ? params.groupName : '');

		$giftCardPreviewWishes.html(wishesHtml);

		//przypisanie wybranych opcji ukrytych pól formularza głównego
		$currentGiftCardGreeting.val(params.whishes ? params.whishes : '');
		$currentCustomWishesData.val(customWishesSelected ? true : false);
		$currentTermsAccepted.val(agreementsSelected ? params.termsAccepted : false);
		$currentAgreementToBlockContent.val(agreementsSelected ? params.agreementToBlockContent : false);

		//zamknięcie modala
		modal.close('gift-card-customization');
	}

	function setCurrentDateForPreview() {
		var date = new Date();
		var yyyy = date.getFullYear() + 1;
		var mm = date.getMonth() + 1 + '';
		if (mm.length === 1) {
			mm = '0' + mm;
		}
		var dd = date.getDate() + '';
		if (dd.length === 1) {
			dd = '0' + dd;
		}
		$('.card-valid-date .input-placeholder').text(yyyy + ' / ' + mm + ' / ' + dd);
	}
	function setPreviewScale() {
		$giftCardPreviewBlock.each(function (i, obj) {
			$previewBlock = $(obj);
			var $giftCardPreview = $('.gift-card-preview', $previewBlock);
			var blockWidth = $previewBlock.width();
			var scaleValue = 100 * blockWidth / 800; // wartość w %
			var previewHeight = $giftCardPreview.height();
			var blockHeight = previewHeight * scaleValue / 100; // wartość w px

			$previewBlock.css('height', blockHeight + 'px');
			$giftCardPreview.css('transform', 'scale(' + scaleValue + '%)');
		})
	}

	function selectCardStyle(cardId, cardSrc, groupName) {
		$currentGiftCardId.val(cardId);
		$previewGroupName.text(groupName);
		$summaryGroupName.text(groupName);
		$previewImage.html('<img src="' + cardSrc + '" alt=""/>');
	}

	function showSelectedGreetingsGroup(selectedGroupId) {
		var $selectedGroup = $greetingListArray.filter('[data-group-id=' + selectedGroupId + ']');
		$greetingListArray.removeClass('visible');
		$selectedGroup.addClass('visible');
	}

	function priceValidate(value) {
		if (value) { //obsługa minimalnej i maksymalnej wartości kwoty
			if (value < 10) {
				value = 10;
			} else if (value > 10000) {
				value = 10000;
			}
		}
		return value;
	}

	function setCardValue(value) {
		currentGiftCardValue = value.toString().replace(/\s/gi, '') / 1 || '';
		$currentGiftCardValue.val(currentGiftCardValue);
		if (currentGiftCardValue) {
			$previewPrice.text(price.format(currentGiftCardValue, true));
			$summaryPrice.text(price.format(currentGiftCardValue, true));
		}
		if (currentGiftCardValue > 0) {
			$form.valid();
		}
	}
	function initGiftCardModalFormValidation() {
		if ($modalForm.length) {
			validate.task('giftCardPersonalization');
		}
	}

	function init() {
		setElements();
		setEvents();
		initGiftCardModalFormValidation();
	}

	return {
		init
	};
});
